module.exports = __webpack_public_path__ + "images/97f5594fe4afd02666ed0714215d862c.jpg";